import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getMessaging } from 'firebase/messaging'
import { getFunctions } from 'firebase/functions'

// Firebase config from Firebase Console web app
const firebaseConfig = {
  apiKey: "AIzaSyA96jGLzCUMVe9FHHS1lQ8vdbi8DFhAs6o",
  authDomain: "chimeo-96dfc.firebaseapp.com",
  databaseURL: "https://chimeo-96dfc-default-rtdb.firebaseio.com",
  projectId: "chimeo-96dfc",
  storageBucket: "chimeo-96dfc.firebasestorage.app",
  messagingSenderId: "280448574070",
  appId: "1:280448574070:web:9cb5298f2f0b10770a7557",
  measurementId: "G-GCSQ5KSTF0"
}

// VAPID key for push notifications
export const VAPID_KEY = "BKj330egH_Do8wrOuLBqR8QqN00tMzJOTxU2XgqpPw2iH8cIvl-m73gYlkDMOwUiyCzr1puqZ_Gza8uEI3uxh9Q"

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase services
export const auth = getAuth(app)

export const db = getFirestore(app)

// Initialize Functions service (only if available)
let functions = null
try {
  
  if (typeof getFunctions !== 'function') {
    throw new Error('getFunctions is not a function')
  }
  
  // Try to initialize functions with error handling
  try {
    functions = getFunctions(app, 'us-central1') // Specify the region
  } catch (functionsError) {
    // Try without region specification
    try {
      functions = getFunctions(app)
    } catch (fallbackError) {
      throw fallbackError
    }
  }
} catch (error) {
  functions = null
}
export { functions }

// Simple messaging initialization
let messaging = null
let messagingInitialized = false
let messagingInitializationPromise = null

// Function to get messaging instance
export const getMessagingInstance = async () => {
  
  // If messaging is already initialized, return it
  if (messagingInitialized && messaging) {
    return messaging
  }
  
  // If there's already an initialization in progress, wait for it
  if (messagingInitializationPromise) {
    return await messagingInitializationPromise
  }
  
  // Start initialization promise
  messagingInitializationPromise = (async () => {
    try {
      // Check if we're in a browser environment
      if (typeof window === 'undefined') {
        return null
      }
      
      // Check if messaging is supported
      if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        console.log('🔍 serviceWorker in navigator:', 'serviceWorker' in navigator)
        console.log('🔍 PushManager in window:', 'PushManager' in window)
        return null
      }
      
      // Check if we're in a secure context (required for messaging)
      if (!window.isSecureContext) {
        console.log('🔍 window.isSecureContext:', window.isSecureContext)
        console.log('🔍 window.location.protocol:', window.location.protocol)
        return null
      }

      // Check if we're on localhost (allowed for development)
      const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
      if (!isLocalhost && !window.isSecureContext) {
        return null
      }
      
      // Check if app is properly initialized
      if (!app || !app.name) {
        console.log('🔍 app:', app)
        console.log('🔍 app.name:', app?.name)
        return null
      }
      
      // Check if messaging is available in the current context
      if (typeof getMessaging !== 'function') {
        return null
      }
      
      // Debug Firebase configuration
      
      // Register service worker first
      try {
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js')
        
        // Wait for service worker to be ready
        await navigator.serviceWorker.ready
      } catch (swError) {
        console.warn('⚠️ getMessagingInstance: Service worker registration failed:', swError)
        // Continue anyway, some browsers might work without explicit registration
      }
      
      // Debug before creating messaging instance
      
      // Create messaging instance
      try {
        messaging = getMessaging(app)
        console.log('🔍 Messaging instance type:', typeof messaging)
        console.log('🔍 Messaging instance constructor:', messaging?.constructor?.name)
      } catch (messagingError) {
        console.error('❌ getMessagingInstance: Error creating messaging instance:', messagingError)
        console.error('❌ getMessagingInstance: Error details:', messagingError.message)
        console.error('❌ getMessagingInstance: Error code:', messagingError.code)
        console.error('❌ getMessagingInstance: Error stack:', messagingError.stack)
        throw messagingError
      }
      
      // Validate the messaging instance
      if (!messaging || typeof messaging.getToken !== 'function') {
        console.log('🔍 messaging:', messaging)
        console.log('🔍 messaging.getToken:', messaging?.getToken)
        return null
      }
      
      messagingInitialized = true
      
      return messaging
      
    } catch (error) {
      console.error('❌ getMessagingInstance: Error initializing messaging:', error)
      console.error('❌ getMessagingInstance: Error details:', error.message)
      console.error('❌ getMessagingInstance: Error code:', error.code)
      console.error('❌ getMessagingInstance: Error stack:', error.stack)
      
      if (error.message.includes('Service messaging is not available')) {
        console.log('  - Service worker not properly registered')
        console.log('  - Browser compatibility issues')
      }
      
      messagingInitialized = false
      messaging = null
      return null
    } finally {
      // Clear the promise so future calls can initialize again
      messagingInitializationPromise = null
    }
  })()
  
  return await messagingInitializationPromise
}

export { messaging }
export default app
